/* eslint-disable i18next/no-literal-string */
export default function FleetSafety() {
  return (
    <div className="p-12">
      <h1 className="text-2xl font-bold">Fleet Safety</h1>
    </div>
  );
}
